import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import "../../assets/scss/components/snackbar.scss";

const Snackbar = ({
    title,
    buttonText,
    onButtonClick,
    duration = 3000,
    isVisible = false,
    onClose,
    type = "success", // "success", "error", "warning", "info"
    bottomPosition = 90, // 기본값 90px
}) => {
    const [isShowing, setIsShowing] = useState(false);

    useEffect(() => {
        if (isVisible) {
            setIsShowing(true);

            const timer = setTimeout(() => {
                setIsShowing(false);
                // 애니메이션 완료 후 onClose 호출
                setTimeout(() => {
                    onClose && onClose();
                }, 300); // 애니메이션 시간과 동일
            }, duration);

            return () => clearTimeout(timer);
        } else {
            setIsShowing(false);
        }
    }, [isVisible, duration, onClose]);

    const handleButtonClick = () => {
        if (onButtonClick) {
            onButtonClick();
        }
        setIsShowing(false);
        setTimeout(() => {
            onClose && onClose();
        }, 300);
    };

    const handleClose = () => {
        setIsShowing(false);
        setTimeout(() => {
            onClose && onClose();
        }, 300);
    };

    if (!isVisible && !isShowing) return null;

    return (
        <div
            className={`snackbar-container ${
                isShowing ? "snackbar-show" : "snackbar-hide"
            }`}
            style={{ bottom: `${bottomPosition}px` }}
        >
            <div className={`snackbar snackbar-${type}`}>
                <div className="snackbar-content">
                    <div className="snackbar-title">{title}</div>
                </div>
                {buttonText ? (
                    <button
                        className="snackbar-button"
                        onClick={handleButtonClick}
                    >
                        {buttonText}
                    </button>
                ) : (
                    <button
                        className="snackbar-close"
                        onClick={handleClose}
                        aria-label="닫기"
                    >
                        ×
                    </button>
                )}
            </div>
        </div>
    );
};

Snackbar.propTypes = {
    title: PropTypes.string.isRequired,
    buttonText: PropTypes.string,
    onButtonClick: PropTypes.func,
    duration: PropTypes.number,
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    type: PropTypes.oneOf(["success", "error", "warning", "info"]),
    bottomPosition: PropTypes.number, // PropTypes 추가
};

export default Snackbar;
